WiseMetering.Views.TariffsTabs = WiseMetering.Views.Content.extend({
    icon: 'tariffs',

    name: function() {
        return i18next.t('glossary.tariffs');
    },

    tabs: function() {
        let tabs = [{
            id: 'tariffs',
            name: i18next.t('glossary.tariffs'),
            active: true,
            view: WiseMetering.Views.IndexTariff
        }];

        const hasSiteInPortugal = WiseMetering.zones.sitesInTimezone('Europe/Lisbon'),
            hasSiteInSpain = WiseMetering.zones.sitesInTimezone('Europe/Madrid');

        if (hasSiteInPortugal.length > 0) {
            tabs.push({
                id: 'tars',
                name: i18next.t('glossary.tar'),
                view: WiseMetering.Views.IndexTars
            });
        }

        if (WiseMetering.currentUser.isSuperUser() && (hasSiteInPortugal || hasSiteInSpain)) {
            tabs.push({
                id: 'omie',
                name: 'OMIE',
                view: WiseMetering.Views.Omie
            });
        }

        return tabs;
    }
});
